module.exports = __webpack_public_path__ + "img/category-Mystery.21ad5b19.svg";